<template>
  <v-container id="balance-overview" tag="section" fluid grid-list-md>
    <base-material-card
      icon="mdi-calendar-clock"
      :title="$t('transactions.balance overview')"
    >
      <v-data-table
        :headers="headers"
        :items="items"
        mobile-breakpoint="500"
        :loading="loading"
        multi-sort
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100, -1],
        }"
      >
        <template v-for="snap in snapshots" v-slot:[`header.${snap.key}`]="{ header }">
          <div :key="`hdr-${snap.key}`">
            <h3>{{ formatAmount(totals[snap.key]) }}</h3>
            {{ header.text }}
          </div>
        </template>

        <template v-for="snap in snapshots" v-slot:[`item.${snap.key}`]="{ item }">
          <div :key="`it-${snap.key}`" class="text-right">
            {{ formatAmount(item[snap.key]) }}
          </div>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
export default {
  name: "BalanceOverviewList",

  data() {
    return {
      loading: true,
      snapshots: [],
      items: [],
      totals: {},
      headers: [],
      sortBy: [],
      sortDesc: [],
    };
  },

  methods: {
    formatAmount(value) {
      const n = Number(value);
      if (!isFinite(n)) return value;
      return n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },

  mounted() {
    this.get("/bookings/balance-overview").then((data) => {
      this.snapshots = data.snapshots || [];
      this.totals = data.totals || {};
      this.items = data.items || [];
      this.headers = [
        {
          text: this.$t("transactions.user"),
          align: "start",
          value: "company",
        },
      ].concat(
        this.snapshots.map((snap) => ({
          text: snap.label,
          value: snap.key,
          align: "right",
          sortable: true,
        }))
      );
      // Default sort: rightmost snapshot (current balance) descending.
      const lastKey = this.snapshots.length
        ? this.snapshots[this.snapshots.length - 1].key
        : null;
      if (lastKey) {
        this.sortBy = [lastKey];
        this.sortDesc = [true];
      }
      this.loading = false;
    });
  },
};
</script>

<style scoped>
.search-field {
  margin-right: 10px;
}
</style>
